import { FileUsageSource, FileUsageTypeEnum } from '@vedalib/editor/lib/files'

import type { IControlProps } from 'components/controls/Field/Field.types'
import FileLoader from 'components/uiKit/FileLoader'
import type { IFieldFileCommon } from 'components/uiKit/FileLoader/FileLoader'

export interface IFieldFileExtended extends IFieldFileCommon {
  value: string
}

/** @deprecated use [FormKit](../../../../components/formKit/fields/index.ts) */
const FieldFileId: React.FC<IControlProps<IFieldFileCommon>> = ({
  value,
  onChange,
  name,
  fileType,
  placeholder,
  defaultValue,
  onFocus,
  onBlur,
  showSource,
  ...rest
}) => {
  const onChangeFile = ({ name, value }: { name: string; value?: { id?: string } | null }) => {
    onChange?.({ name, value: value?.id })
  }
  const id = (value || defaultValue) as string

  return (
    <FileLoader
      fileType={fileType}
      name={name}
      onBlur={onBlur}
      // @ts-expect-error TODO
      onChange={onChangeFile}
      onFocus={onFocus}
      showSource={showSource}
      source={FileUsageSource.file}
      value={id ? { id, type: FileUsageTypeEnum.image } : null}
      {...rest}
    />
  )
}

export default FieldFileId
